import { UIServiceError } from "@flights/types";
import { FLIGHT_DETAILS_RETRYABLE_ERROR_CODES, RETRY_NETWORK_ERROR_FOR_GAPD } from "../constants";
// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useStore } from "../store";
import { flightsSessionStore } from "@flights/web-api-utils-universal";

export default function useRetryFlightDetailsApi() {
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();
  const { fetchStatus, error } = store.flightDetails;
  const serviceError = error as UIServiceError;

  const isRetryableFlightDetails = (): boolean => {
    if (
      fetchStatus == "failed" &&
      FLIGHT_DETAILS_RETRYABLE_ERROR_CODES.includes(serviceError?.code) &&
      flightsSessionStore.get(RETRY_NETWORK_ERROR_FOR_GAPD)
    ) {
      return true;
    }
    return false;
  };

  const setFlightDetailsApiForRetry = (error: UIServiceError) => {
    if (FLIGHT_DETAILS_RETRYABLE_ERROR_CODES.includes(error.code)) {
      flightsSessionStore.set(RETRY_NETWORK_ERROR_FOR_GAPD, true);
    }
  };

  const unSetFlightDetailsApiForRetry = () => {
    flightsSessionStore.unset(RETRY_NETWORK_ERROR_FOR_GAPD);
  };

  return {
    isRetryableFlightDetails,
    setFlightDetailsApiForRetry,
    unSetFlightDetailsApiForRetry
  };
}
